/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class HomeApi {
    static getInstance() {
        if (!this.instance) this.instance = new HomeApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 获取售车总数，上周激活用户数
    async getActivationRate (){
        // let url = `/api/sys/vehicle/activation/rate`
        let url = `/api/sys/vehicle/count`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 获取上周激活用户数
    async getLastWeekActiveNum(start,end){
        let url = `/api/sys/ride/series/count?start=${start}&end=${end}` 
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 获取上周活跃用户数
    async getSegmentCount(start,end){
        // let url = `/api/sys/ride/series/count?start=${start}&end=${end}`  
        let url = `/api/sys/vehicle/bind/count?start=${start}&end=${end}`  
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 获取激活用户城市分布
    async getCityDistribution(){
        let url = `/api/sys/users/city/rate`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 获取城市分布列表
    async getCityList(param){
        // let url = `/api/sys/users/city/list`    
        let url = `/api/sys/v2/vehicle/location/list`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 获取最大扭矩
    async getMaxTorque(param){
        let url = `/api/sys/vehicle/maxTorque/count`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 下载最大扭矩
    async downloadMaxTorque(param){
        let url = `/api/sys/vehicle/maxTorque/download`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取管理员邮箱
    async getAdminEmail(tenant_id){
        let url = `/api/sys/account/auth/record/admin/email?tenant_id=${tenant_id}`
        let result = await this.getData(url,{},'GET')
        return result
    }

}

export {
    HomeApi
}